import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import PersonalizeDataGrid from "../../Components/Table/PersonalizeDataGrid";

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function appColumns(applications) {
  return (applications || []).map((app) => ({
    field: `app_${app.application_id}`,
    label: app.application_name || `App ${app.application_id}`,
    visible: true,
    width: 140,
    required: false,
  }));
}

export function PermissionsPersonalizeView() {
  const [applications, setApplications] = useState([]);
  const [modules, setModules] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${MAIN_URL}/api/core/permission-assignment`, {
        headers: authHeaders(),
      })
      .then((res) => {
        if (cancelled) return;
        const d = res.data || {};
        setApplications(d.applications || []);
        setModules(d.modules || []);
      })
      .catch(() => {
        if (!cancelled) {
          setApplications([]);
          setModules([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const rows = useMemo(() => {
    const next = [];
    modules.forEach((mod) => {
      next.push({
        row_id: `m-${mod.module_id}`,
        name: mod.module_name,
      });
      (mod.features || []).forEach((feature) => {
        next.push({
          row_id: `f-${feature.module_feature_id}`,
          name: feature.module_feature_name,
        });
      });
    });
    return next;
  }, [modules]);

  const configss = useMemo(
    () => [
      {
        field: "name",
        label: "Module / feature",
        visible: true,
        width: 280,
        required: true,
      },
      ...appColumns(applications),
    ],
    [applications]
  );

  return (
    <PersonalizeDataGrid
      tableName="permission_assignment"
      displayTitle="Permissions access"
      data={rows}
      configss={configss}
    />
  );
}

export function UserRolesPersonalizeView() {
  const [applications, setApplications] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${MAIN_URL}/api/core/user-role-assignment`, {
        headers: authHeaders(),
      })
      .then((res) => {
        if (cancelled) return;
        const d = res.data || {};
        setApplications(d.applications || []);
        setRoles(d.roles || []);
      })
      .catch(() => {
        if (!cancelled) {
          setApplications([]);
          setRoles([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const configss = useMemo(
    () => [
      {
        field: "user_role_name",
        label: "System role",
        visible: true,
        width: 260,
        required: true,
      },
      ...appColumns(applications),
    ],
    [applications]
  );

  return (
    <PersonalizeDataGrid
      tableName="user_role_assignment"
      displayTitle="User roles access"
      data={roles}
      configss={configss}
    />
  );
}
